export const MIN_HEIGHT = 720; // Minimum height for the main content area in pixels
export const MAX_WIDTH = 1440; // Approx. 19-inch screen width in pixels
export const NAVBAR_WIDTH = 400;
export const NAVBAR_COLLAPSED_WIDTH = 20;
export const FOOTER_HEIGHT = 56; // Footer height in pixels
export const HEADER_HEIGHT = 120; // Header height in pixels
export const DEFAULT_PAGE_SIZE = 30; // Default page size for paginated lists
export const PRINT_MARGIN = 10;
